import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  ipAddress: "192.168.1.55",
  computerName: "SUBE-PC-01",
  branchName: "Merkez Şube",
  branchCode: "001",
  online: true,
  appVersion: "v1.0.0",
};

const systemSlice = createSlice({
  name: "system",
  initialState,
  reducers: {
    setOnline: (state, action) => {
      state.online = action.payload;
    },
    setIp: (state, action) => {
      state.ipAddress = action.payload;
    },
  },
});

export const { setOnline, setIp } = systemSlice.actions;
export default systemSlice.reducer;
